import React, { Component } from 'react';
import Radium from 'radium';
import { func, node, string, number, shape, arrayOf, bool, element, oneOfType } from 'prop-types';

import UTListItem from './components/UTListItem';
import styles from './styles';

class UTList extends Component {
  constructor(props) {
    super(props);
    this.listRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.handleScroll);
  }

  isBottom = () =>
    this.listRef.current && this.listRef.current.getBoundingClientRect().bottom <= window.innerHeight;

  handleScroll = () => {
    const { onEndReached } = this.props;

    if (onEndReached && this.isBottom()) {
      onEndReached();
    }
  };

  renderListItem = (item, index, array) => (
    <UTListItem
      key={item.id}
      active={this.props.active}
      onClick={this.props.onClick}
      index={index}
      countElements={array.length}
      item={item}
    />
  );

  render() {
    const { list, style } = this.props;

    return (
      <ul ref={this.listRef} style={[styles.container, style]}>
        {list.map(this.renderListItem)}
      </ul>
    );
  }
}

UTList.propTypes = {
  active: bool,
  list: arrayOf(
    shape({
      id: number.isRequired,
      icon: oneOfType([string, element]),
      title: string.isRequired,
      subtitle: string,
      rightButton: node
    })
  ).isRequired,
  onClick: func,
  onEndReached: func
};

export default Radium(UTList);
